var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifySuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0001 6.3335L46.3178 12.4009L56.6133 12.3813L59.7761 22.179L68.1168 28.2147L64.9168 38.0002L68.1168 47.7856L59.7761 53.8213L56.6133 63.619L46.3178 63.5995L38.0001 69.6668L29.6824 63.5995L19.3869 63.619L16.224 53.8213L7.8833 47.7856L11.0834 38.0002L7.8833 28.2147L16.224 22.179L19.3869 12.3813L29.6824 12.4009L38.0001 6.3335Z",
    fill: "#21BCE7",
    stroke: "#204B90",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9167 38.0002L34.8334 45.9168L50.6667 30.0835",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifySuccess);
export default __webpack_public_path__ + "static/media/verify_success.dfaedf73.svg";
export { ForwardRef as ReactComponent };